import { defineStore } from 'pinia';
import { ref } from 'vue';
export let useProductDetailStore = defineStore('productDetailStore', ()=>{
    let productCode = ref('');
    let categoryCodes = ref([]);
    return {
        productCode,
        categoryCodes
    }
})